/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2LocationPin/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2LocationPin({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2LocationPin",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 11,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2LocationPin.Svg"
  data-view-path={viewPath}
 viewBox="0 0 11 12"
 style={{'--as-1-1MdtNK': alignSelf,'--mt-2-1MdtNK': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1MdtNK': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1MdtNK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1MdtNK': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1MdtNK': opacity,'--w-10-1MdtNK': typeof width === 'number' ? `${width}px` : width,'--h-11-1MdtNK': typeof height === 'number' ? `${height}px` : height,'--f-12-1MdtNK': fill,'--a-7-1MdtNK': isAnimated ? animation : "none",'--sd-8-1MdtNK': isAnimated ? strokeDashoffset : 0,'--sd-9-1MdtNK': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2LocationPin.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M5.089.002C2.271.002 0 2.329 0 5.182 0 6.884.844 8.352 1.794 9.47c.953 1.12 2.05 1.93 2.638 2.326.4.269.915.269 1.314 0 .589-.396 1.685-1.206 2.638-2.326.95-1.117 1.794-2.585 1.794-4.289 0-2.852-2.27-5.179-5.089-5.179zM4.018 3c0-.118.096-.214.214-.214h1.714c.118 0 .214.096.214.214V4.07h1.072c.118 0 .214.096.214.215V6a.214.214 0 01-.214.214H6.16v1.071a.214.214 0 01-.214.215H4.232a.214.214 0 01-.214-.215V6.214H2.946A.214.214 0 012.732 6V4.286c0-.119.096-.215.214-.215h1.072V3z"
 style={{'--f-12-1MdtNK': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}